import React from 'react';
// import library slide
import Swiper from 'react-id-swiper';
// Banner Image
import Banner1 from '../../assets/images/banner/1.jpg';
import Banner2 from '../../assets/images/banner/2.jpg';
// import css react swiper id
import 'swiper/css/swiper.css';
// import 'swiper/css/swiper.css';
import './BannerSlide.css';
const BannerSlide = () => {
  const params = {
    slidesPerView: 1,
    // spaceBetween: 30,
    slidesPerGroup: 1,
    loop: true,
    loopFillGroupWithBlank: false,
    autoplay: {
      delay: 2500,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      // renderBullet: (index, className) => {
      //   return '<span class="' + className + '">' + (index + 1) + '</span>';
      // },
    },
  };
  return (
    <>
      <Swiper {...params}>
        <div className="bg-gradient-to-r from-orange-400 to-orange-300 w-full flex rounded">
          <div
            className="w-full h-64 bg-cover rounded-md"
            style={{ backgroundImage: `url(${Banner2})` }}
          ></div>
        </div>
        <div className="bg-gradient-to-r from-orange-400 to-orange-300 w-full flex rounded ">
          <div
            className="w-full h-64 bg-cover rounded-md"
            style={{ backgroundImage: `url(${Banner1})` }}
          ></div>
        </div>
        {/* <div className="bg-gradient-to-r from-orange-400 to-orange-300 w-full flex rounded ">
          <div className="w-full">
            <img src={Banner2} alt="Banner Promo" className="h-auto" />
          </div>
        </div>
        <div className="bg-gradient-to-r from-orange-400 to-orange-300 w-full flex rounded ">
          <div className="w-full">
            <img src={Banner3} alt="Banner Promo" className="h-auto" />
          </div>
        </div>
        <div className="bg-gradient-to-r from-orange-400 to-orange-300 w-full flex rounded ">
          <div className="w-full">
            <img src={Banner4} alt="Banner Promo" className="h-auto" />
          </div>
        </div> */}
      </Swiper>
    </>
  );
};

export default BannerSlide;
